const artistsNL = {
    "view": {
        "table": {
            "title": "Uw artiestenlijst",
            "column": {
                "name": "Artiestnaam",
                "owner": "Eigenaar",
                "spotify_link": "Spotify Link",
                "apple_music_link": "Apple Music Link",
                "amazon_music_link": "Amazon Music Link",
                "deezer_link": "Deezer Link",
                "flagged": "Gemarkeerd",
                "blacklisted": "Op de zwarte lijst",
                "action": "Actie"
            },
            "button": {
                "export_csv": "Exporteer CSV"
            },
            "placeholder": {
                "search": "Zoeken..."
            },
            "message": {
                "artistFlagged": "Deze artiest is gemarkeerd en een escrow-betaling is vereist om de release naar Spotify te distribueren.",
                "artistNotFlagged": "Deze artiest komt in aanmerking voor Spotify-distributie.",
                "artistBlacklisted": "Deze artiest is op de zwarte lijst en niet in aanmerking voor distributie.",
                "artistNotBlacklisted": "Deze artiest is niet op de zwarte lijst en in aanmerking voor distributie.",
            }
        },
        "message": {
            "success": "Artiest is verwijderd!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!",
            "notSubscribed": "U bent niet geabonneerd op een plan, daarom kunt u slechts <strong>3 Artiesten</strong> toevoegen. Gelieve te <3>abonneren</3> op een plan om een onbeperkt aantal artiesten toe te voegen.",
            "subscriptionUpgrade": "Uw huidige abonnementsplan ondersteunt deze functie niet. Gelieve uw abonnementsplan te <1>upgraden</1> om deze functie te gebruiken.",
            "subscriptionExpired": "Uw abonnement is verlopen. Gelieve uw abonnement te <1>hervatten</1> om deze functie te gebruiken.",
            "noAccess": "U heeft geen toegang tot deze module, neem contact op met het ondersteuningsteam voor meer informatie."
        },
        "modal": {
            "cantBeDeleted": {
                "header": "Artiest {{artistName}} kan niet worden verwijderd",
                "body": "Artiest {{artistName}} kan niet worden verwijderd omdat er al Track(s)/Release(s) aan zijn gekoppeld."
            },
            "delete": {
                "header": "Verwijder {{artistName}}?",
                "body": "Weet u zeker dat u deze artiest echt wilt verwijderen? Deze actie kan uw artiest loskoppelen van de toegewezen release."
            },
            "edit": {
                "header": "Bewerk {{artistName}}?",
                "body": "Weet u zeker dat u de naam van uw artiest wilt wijzigen? Dit kan invloed hebben op de release-metadata."
            }
        }
    },
    "add": {
        "title": "Artiest Toevoegen",
        "form": {
            "label": {
                "is_new_artist": "Is Nieuwe Artiest",
                "spotify_profile": "Spotify Profiel",
                "deezer_profile": "Deezer Profiel",
                "amazon_music_profile": "Amazon Music Profiel",
                "spotify_image": "Spotify Afbeelding",
                "deezer_image": "Deezer Afbeelding",
                "amazon_music_image": "Amazon Music Afbeelding",
                "spotify_id": "Spotify ID",
                "deezer_id": "Deezer ID",
                "amazon_music_id": "Amazon Music ID",
                "apple_id": "Apple ID",
                "name": "Naam",
                "name_preference": "Naamvoorkeur",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "E-mail",
                "subuser": "Sub-gebruiker"
            },
            "help_text": {
                "is_new_artist": "Voegt u een nieuwe artiest toe, d.w.z. als uw artiest releases heeft op Spotify/Deezer/Amazon Music/Apple Music, selecteer dan Nee, anders selecteer Ja.",
                "spotify_profile": "Opmerking: Gebruik deze dropdown alleen als u een artiest wilt toevoegen die al op Spotify staat, anders klikt u op de knop Niet Gevonden.",
                "deezer_profile": "Opmerking: Gebruik deze dropdown alleen als u een artiest wilt toevoegen die al op Deezer staat, anders klikt u op de knop Niet Gevonden.",
                "amazon_music_profile": "Opmerking: Gebruik deze dropdown alleen als u een artiest wilt toevoegen die al op Amazon Music staat, anders klikt u op de knop Niet Gevonden.",
                "apple_id": "Opmerking: Gebruik dit veld alleen als u een artiest wilt toevoegen die al op Apple Music staat, anders klikt u op de knop Niet Gevonden.",
                "subuser": "Opmerking: Gebruik deze dropdown alleen als u een artiest wilt toevoegen voor een van uw sub-gebruikers, anders laat u deze niet geselecteerd."
            },
            "placeholder": {
                "subuser": "Selecteer Sub-gebruiker...",
                "spotify_profile": "Voer Artiestnaam in, bijv. The Weekend of Artiest's Spotify ID, bijv. 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Voer Artiestnaam in, bijv. The Weekend of Artiest's Deezer ID, bijv. 1406580",
                "amazon_music_profile": "Voer Artiestnaam in, bijv. The Weekend of Artiest's Amazon ASIN, bijv. B005GI0T2U",
                "apple_id": "Voer een geldige Apple ID in. Voorbeeld: 635806095"
            },
            "button": {
                "reset": "Reset",
                "not_found": "Niet Gevonden",
                "submit": "Indienen"
            },
            "option": {
                "yes": "Ja",
                "no": "Nee"
            },
            "validation": {
                "name_required": "Naam is vereist",
                "name_invalid": "Artiestnaam moet 'DJ' alleen in hoofdletters bevatten",
                "email_required": "E-mail is vereist",
                "email_invalid": "Voer een geldig e-mailadres in",
                "name_duplicate": "Artiest bestaat al",
                "name_mismatch": "Artiestnaam moet overeenkomen voor alle winkels",
                "spotify_id_invalid": "Voeg een geldige Spotify ID toe. Voorbeeld: 6eUKZXaKkcviH0Ku9w2n3B. Raadpleeg ons Helpcentrum voor meer informatie.",
                "apple_id_required": "Apple ID is vereist",
                "apple_id_invalid": "Voeg een geldige Apple ID toe. Voorbeeld: 635806095. Raadpleeg ons Helpcentrum voor meer informatie."
            }
        },
        "modal": {
            "title": {
                "new_artist_declaration": "Verklaring Nieuwe Artiest",
                "profile_not_present_declaration": "Verklaring Profiel Niet Aanwezig"
            },
            "body": {
                "profile_not_present_declaration": "Ik bevestig dat het profiel van deze artiest niet aanwezig is op <strong>{{store}}</strong> en dat het profiel van deze artiest nieuw wordt aangemaakt op <strong>{{store}}</strong>.",
                "new_artist_declaration": "Ik bevestig dat het profiel van deze artiest niet aanwezig is in een van de volgende winkels en dat het profiel van deze artiest nieuw wordt aangemaakt in deze winkels.",
                "new_artist_declaration_amazon_music": "Amazon Music",
                "new_artist_declaration_apple_music": "Apple Music",
                "new_artist_declaration_deezer": "Deezer",
                "new_artist_declaration_spotify": "Spotify"
            },
            "button": {
                "confirm": "Bevestigen",
                "cancel": "Annuleren"
            }
        },
        "message": {
            "success": "Artiest is toegevoegd!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!",
            "errorBlacklisted": "Een of meerdere van de details die u hebt verstrekt zijn gerelateerd aan een artiest die is gesperd. Als u er zeker van bent dat de artiest niet is gesperd, neem dan contact op met het ondersteuningsteam voor meer informatie."
        }
    },
    "update": {
        "title": "Artiest Bewerken",
        "form": {
            "label": {
                "spotify_profile": "Spotify Profiel",
                "deezer_profile": "Deezer Profiel",
                "amazon_music_profile": "Amazon Music Profiel",
                "spotify_image": "Spotify Afbeelding",
                "deezer_image": "Deezer Afbeelding",
                "amazon_music_image": "Amazon Music Afbeelding",
                "spotify_id": "Spotify ID",
                "deezer_id": "Deezer ID",
                "amazon_music_id": "Amazon Music ID",
                "apple_id": "Apple ID",
                "name": "Naam",
                "name_preference": "Naamvoorkeur",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "E-mail",
                "flagged": "Gemarkeerd"
            },
            "help_text": {
                "spotify_profile": "Opmerking: Gebruik deze dropdown alleen als u een artiest wilt toevoegen die al op Spotify staat, anders klikt u op de knop Niet Gevonden.",
                "deezer_profile": "Opmerking: Gebruik deze dropdown alleen als u een artiest wilt toevoegen die al op Deezer staat, anders klikt u op de knop Niet Gevonden.",
                "amazon_music_profile": "Opmerking: Gebruik deze dropdown alleen als u een artiest wilt toevoegen die al op Amazon Music staat, anders klikt u op de knop Niet Gevonden.",
                "apple_id": "Opmerking: Gebruik dit veld alleen als u een artiest wilt toevoegen die al op Apple Music staat, anders klikt u op de knop Niet Gevonden."
            },
            "placeholder": {
                "spotify_profile": "Voer Artiestnaam in, bijv. The Weekend of Artiest's Spotify ID, bijv. 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Voer Artiestnaam in, bijv. The Weekend of Artiest's Deezer ID, bijv. 1406580",
                "amazon_music_profile": "Voer Artiestnaam in, bijv. The Weekend of Artiest's Amazon ASIN, bijv. B005GI0T2U",
                "apple_id": "Voer een geldige Apple ID in. Voorbeeld: 635806095"
            },
            "button": {
                "reset": "Reset",
                "not_found": "Niet Gevonden",
                "submit": "Indienen"
            },
            "validation": {
                "name_required": "Naam is vereist",
                "email_required": "E-mail is vereist",
                "email_invalid": "Voer een geldig e-mailadres in",
                "name_duplicate": "Artiest bestaat al",
                "name_mismatch": "Artiestnaam moet overeenkomen voor alle winkels",
                "name_mismatch_spotify": "Spotify Profielnaam moet overeenkomen met de Artiestnaam",
                "name_mismatch_deezer": "Deezer Profielnaam moet overeenkomen met de Artiestnaam",
                "name_mismatch_amazon_music": "Amazon Profielnaam moet overeenkomen met de Artiestnaam",
                "spotify_id_invalid": "Voeg een geldige Spotify ID toe. Voorbeeld: 6eUKZXaKkcviH0Ku9w2n3B. Raadpleeg ons Helpcentrum voor meer informatie.",
                "apple_id_required": "Apple ID is vereist",
                "apple_id_invalid": "Voeg een geldige Apple ID toe. Voorbeeld: 635806095. Raadpleeg ons Helpcentrum voor meer informatie."
            }
        },
        "modal": {
            "title": {
                "profile_reset_declaration": "Verklaring Profiel Reset",
                "profile_not_present_declaration": "Verklaring Profiel Niet Aanwezig"
            },
            "body": {
                "profile_not_present_declaration": "Ik bevestig dat het profiel van deze artiest niet aanwezig is op <strong>{{store}}</strong> en dat het profiel van deze artiest nieuw wordt aangemaakt op <strong>{{store}}</strong>.",
                "profile_reset_declaration": "Ik ben me ervan bewust dat door het resetten van het <strong>{{store}}</strong> profiel van deze artiest de <strong>{{store}} ID</strong> overal in het systeem wordt verwijderd en dat dit waarschijnlijk verstoringen in de winkels en artiesten zal veroorzaken."
            },
            "button": {
                "confirm": "Bevestigen",
                "cancel": "Annuleren"
            }
        },
        "message": {
            "success": "Artiest met naam '{{artistName}}' is bijgewerkt!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!",
            "errorBlacklisted": "Een of meerdere van de details die u hebt verstrekt zijn gerelateerd aan een artiest die is gesperd. Als u er zeker van bent dat de artiest niet is gesperd, neem dan contact op met het ondersteuningsteam voor meer informatie."
        }
    },
    "add_from_wishlist": {
        "title": "Artiest Toevoegen",
        "form": {
            "label": {
                "spotify_profile": "Spotify Profiel",
                "deezer_profile": "Deezer Profiel",
                "amazon_music_profile": "Amazon Music Profiel",
                "spotify_id": "Spotify ID",
                "spotify_image": "Spotify Afbeelding",
                "deezer_id": "Deezer ID",
                "deezer_image": "Deezer Afbeelding",
                "amazon_music_id": "Amazon ID",
                "amazon_music_image": "Amazon Music Afbeelding",
                "apple_id": "Apple ID",
                "apple_image": "Apple Afbeelding",
                "name": "Naam",
                "name_preference": "Naamvoorkeur",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "E-mail",
                "subuser": "Sub-gebruiker"
            },
            "placeholder": {
                "spotify_profile": "Voer Artiestnaam in, bijv. The Weekend of Artiest's Spotify ID, bijv. 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Voer Artiestnaam in, bijv. The Weekend of Artiest's Deezer ID, bijv. 1406580",
                "amazon_music_profile": "Voer Artiestnaam in, bijv. The Weekend of Artiest's Amazon ASIN, bijv. B005GI0T2U",
                "apple_id": "Voer een geldige Apple ID in. Voorbeeld: 635806095",
                "subuser": "Selecteer Sub-gebruiker..."
            },
            "help_text": {
                "spotify_profile": "Opmerking: Gebruik deze dropdown alleen als u een artiest wilt toevoegen die al op Spotify staat, anders klikt u op de knop Niet Gevonden.",
                "deezer_profile": "Opmerking: Gebruik deze dropdown alleen als u een artiest wilt toevoegen die al op Deezer staat, anders klikt u op de knop Niet Gevonden.",
                "amazon_music_profile": "Opmerking: Gebruik deze dropdown alleen als u een artiest wilt toevoegen die al op Amazon Music staat, anders klikt u op de knop Niet Gevonden.",
                "apple_id": "Opmerking: Gebruik dit veld alleen als u een artiest wilt toevoegen die al op Apple Music staat, anders klikt u op de knop Niet Gevonden.",
                "subuser": "Opmerking: Gebruik deze dropdown alleen als u een artiest wilt toevoegen voor een van uw sub-gebruikers, anders laat u deze niet geselecteerd."
            },
            "button": {
                "reset": "Reset",
                "notFound": "Niet Gevonden?",
                "submit": "Indienen",
                "cancel": "Annuleren",
                "confirm": "Bevestigen"
            },
            "validation": {
                "name_required": "Naam is vereist",
                "email_required": "E-mail is vereist",
                "email_invalid": "Voer een geldig e-mailadres in",
                "spotify_id_invalid": "Voeg een geldige Spotify ID toe. Voorbeeld: 6eUKZXaKkcviH0Ku9w2n3B. Raadpleeg ons Helpcentrum voor meer informatie.",
                "apple_id_required": "Apple ID is vereist",
                "apple_id_invalid": "Voeg een geldige Apple ID toe. Voorbeeld: 635806095. Raadpleeg ons Helpcentrum voor meer informatie."
            },
            "message": {
                "errorArtistExists": "Artiest bestaat al",
                "errorNameMismatch": "Artiestnaam moet overeenkomen voor alle winkels",
                "errorSpotifyNameMismatch": "Spotify Profielnaam moet overeenkomen met de Artiestnaam",
                "errorDeezerNameMismatch": "Deezer Profielnaam moet overeenkomen met de Artiestnaam",
                "errorAmazonNameMismatch": "Amazon Profielnaam moet overeenkomen met de Artiestnaam"
            }
        },
        "message": {
            "success": "Artiest is toegevoegd!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!",
            "errorBlacklisted": "Een of meerdere van de details die u hebt verstrekt zijn gerelateerd aan een artiest die is gesperd. Als u er zeker van bent dat de artiest niet is gesperd, neem dan contact op met het ondersteuningsteam voor meer informatie."
        },
        "modal": {
            "profileMissing": {
                "header": "Verklaring Profiel Niet Aanwezig",
                "body": "Ik bevestig dat het profiel van deze artiest niet aanwezig is op <strong>{{storeName}}</strong> en dat het profiel van deze artiest nieuw wordt aangemaakt op <strong>{{storeName}}</strong>.",
                "button": {
                    "cancel": "Annuleren",
                    "confirm": "Bevestigen"
                }
            }
        }
    },
    "viewDetails": {
        "view": {
            "label": {
                "followers": "VOLGERS",
                "popularity": "POPULARITEIT",
                "genres": "GENRES",
                "flagged": "GEMARKEERD",
                "notAvailable": "Niet Beschikbaar",
                "notAvailableAbbr": "N/B"
            },
            "similarArtists": {
                "title": "Vergelijkbare Artiesten",
                "table": {
                    "column": {
                        "artist": "Artiest",
                        "followers": "Volgers",
                        "popularity_pct": "Populariteit (%)",
                        "genres": "Genres",
                        "wishlist": "Verlanglijst"
                    }
                },
                "label": {
                    "notAvailable": "Niet Beschikbaar",
                    "notAvailableAbbr": "N/B"
                },
                "message": {
                    "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
                },
                "modal": {
                    "addToWishlist": {
                        "header": "Voeg Artiest {{artistName}} Toe aan Verlanglijst",
                        "body": "Weet u zeker dat u artiest {{artistName}} aan uw verlanglijst wilt toevoegen?",
                        "message": {
                            "success": "Artiest toegevoegd aan verlanglijst!"
                        }
                    },
                    "removeFromWishlist": {
                        "header": "Verwijder Artiest {{artistName}} van Verlanglijst",
                        "body": "Weet u zeker dat u artiest {{artistName}} van uw verlanglijst wilt verwijderen?"
                    }
                }
            },
            "topTracks": {
                "title": "Topnummers",
                "table": {
                    "column": {
                        "track": "Nummer",
                        "release": "Release",
                        "artists": "Artiest(en)",
                        "popularity_pct": "Populariteit (%)",
                        "preview": "Voorbeeld"
                    }
                },
                "label": {
                    "audioElementNotSupported": "Uw browser ondersteunt het audio-element niet."
                }
            }
        }
    }
};

export default artistsNL;